import { LyDialog } from "@alyle/ui/dialog";
import {
    animate,
    state,
    style,
    transition,
    trigger,
} from "@angular/animations";
import {
    AfterViewInit,
    ChangeDetectorRef,
    Component,
    ElementRef,
    EventEmitter,
    HostListener,
    OnDestroy,
    OnInit,
    Output,
    Renderer2,
    ViewChild,
    isDevMode,
} from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";
import { CropperComponent } from "@fuse/Dialog/cropper/cropper.component";
import { fuseAnimations } from "@fuse/animations";
import { CommonService } from "@fuse/services/common.service";
import { ToolbarService } from "app/layout/components/toolbar/toolbar.service";
import { NgxFileDropEntry } from "ngx-file-drop";
import { CertificateToolService } from "./certificate-tool.service";
import { FormBuilder, FormGroup } from "@angular/forms";
import { Validators } from "ngx-editor";
import { MatDialog } from "@angular/material/dialog";
import { CommonMessageSubmitComponent } from "@fuse/Dialog/common-message-submit/common-message-submit.component";
import { Router } from "@angular/router";
import { CertificateUpdateService } from "./certificate-update.service";
import { ConfirmationDialogComponent } from "@fuse/Dialog/confirmation-dialog/confirmation-dialog.component";
import { financial } from "@fuse/utils/systemEnums";
import { Subject } from "rxjs";
import { debounceTime } from "rxjs/operators";

@Component({
    selector: "app-create-certificate",
    templateUrl: "./create-certificate.component.html",
    styleUrls: ["./create-certificate.component.scss"],
    animations: [
        trigger("slideInOut", [
            state(
                "in",
                style({
                    right: 0,
                })
            ),
            state(
                "out",
                style({
                    right: "-275px",
                })
            ),
            transition("in => out", animate("300ms ease-out")),
            transition("out => in", animate("300ms ease-in")),
        ]),
        trigger("showHide", [
            transition(":enter", [
                style({ transform: "translateY(-20px)", opacity: 0 }),
                animate(
                    200,
                    style({ transform: "translateY(0px)", opacity: 1 })
                ),
            ]),
            transition(":leave", [
                animate(
                    200,
                    style({ transform: "translateY(-20px)", opacity: 0 })
                ),
            ]),
        ]),
        fuseAnimations,
    ],
})
export class CreateCertificateComponent
    implements OnInit, OnDestroy, AfterViewInit {
    // templateBg: string = "";
    showSideBar: boolean = false;
    selectedEleId = null;
    parentElement: string = "";
    clickTimer;
    form: FormGroup;
    showMoveableLine: boolean = false;
    backgrounds: [] = [];
    certificate = "certificate";
    zoomScale = 100;

    public menuState = "out";
    isDragging: boolean;
    offsetX: number;
    offsetY: number;
    selectedItem: any;
    dimensions: { width: number; height: number; aspectRatio: number };

    // Array of lines with position and percentage properties
    lines = [
        { position: 25, percentage: 0, isDragging: false, type: "V", isActive: false }, // Example line
        { position: 75, percentage: 0, isDragging: false, type: "V", isActive: false }, // Add more lines as needed
        { position: 25, percentage: 0, isDragging: false, type: "H", isActive: false }, // Add more lines as needed
        { position: 75, percentage: 0, isDragging: false, type: "H", isActive: false }, // Add more lines as needed
    ];

    // Array of Subjects for debouncing each line's percentage
    percentageSubjects: Subject<number>[] = [];

    isDraggingLine = false;
    activeLineIndex: number | null = null;
    @ViewChild("parentContainer", { static: false })
    parentContainer: ElementRef;
    private mouseMoveHandler: (event: MouseEvent) => void;
    private mouseUpHandler: (event: MouseEvent) => void;
    isPaintFormatActive: boolean = false;
    paintFormatCopiedElement;

    cursorX: any = 0;
    cursorY: any = 0;

    isHovering: boolean = false;


    currentTab: string = 'Contact Actions';
    selectedTabIndex: number = 0; // 0 for Contact Actions, 1 for Attendees Actions

    onTabChange(event: any) {
        this.currentTab = event.tab.textLabel;
        this.selectedTabIndex = event.index;
        this.menuState = 'out'; // Close the right side nav

        // Clear all dynamic elements
        this._certificateToolService.templateData.dynamicElements = [];

        // Reset signature to default state
        this._certificateToolService.templateData.signature = {
            elementType: "image",
            link: "",
            width: 100,
            display: true,
            opacity: 1,
            rotate: 0,
            position: {
                top: 31.99,
                left: 90.5,
            },
        };

        // Reset selection
        this.selectedEleId = null;
        this.parentElement = "";
    }

    toggleMenu() {
        this.menuState = this.menuState === "out" ? "in" : "out";
    }

    constructor(
        private _ToolbarService: ToolbarService,
        private _snackBar: MatSnackBar,
        private _router: Router,
        private renderer: Renderer2,
        private _matDialog: MatDialog,
        private _fb: FormBuilder,
        private _CertificateUpdateService: CertificateUpdateService,
        private _cd: ChangeDetectorRef,
        public _certificateToolService: CertificateToolService,
        private _dialog: LyDialog,
        private _commonService: CommonService
    ) {
        if (this._CertificateUpdateService.templateDetails) {
            this.setToolBarTitle(true);
            this.createForm(this._CertificateUpdateService.templateDetails);
            this._certificateToolService.templateData =
                this._CertificateUpdateService.templateDetails.layout;
            // Set currentTab and selectedTabIndex based on attachType

            console.log("templateDetails.attachType", this._CertificateUpdateService.templateDetails.attachType);



            this.currentTab = this._CertificateUpdateService.templateDetails.attachType === 1 ? 'Contact Actions' : 'Attendees Actions';
            this.selectedTabIndex = this._CertificateUpdateService.templateDetails.attachType === 1 ? 0 : 1;
            console.log(
                "this._CertificateUpdateService.templateDetails.layout",
                this._CertificateUpdateService.templateDetails
            );
            console.log(
                "this._certificateToolService.templateData",
                this._certificateToolService.templateData
            );
        } else {
            this.setToolBarTitle(false);
            this.createForm();
            // Set default tab for new certificate
            this.currentTab = 'Contact Actions';
            this.selectedTabIndex = 0;
        }
        this.getAllBackgroundImages();

        this.mouseMoveHandler = this.onMouseMove.bind(this);
        this.mouseUpHandler = this.onMouseUp.bind(this);
    }

    ngOnInit(): void { }

    @HostListener("document:keydown", ["$event"]) onClickEvent(event: any) {
        let keys = event.keyCode;
        if (this.selectedEleId) {
            switch (keys) {
                case 37:
                    this.leftClick();
                    break;
                case 38:
                    this.upClick();
                    break;
                case 39:
                    this.rightClick();
                    break;
                case 40:
                    this.downClick();
                    break;
            }
        }
    }

    ngAfterViewInit() {
        // Initialize subjects for each line
        this.lines.forEach((_, index) => {
            const subject = new Subject<number>();
            this.percentageSubjects.push(subject);

            // Subscribe with debounceTime for each line
            subject.pipe(debounceTime(100)).subscribe((value) => {
                this.lines[index].percentage = value;
            });
        });
    }

    setToolBarTitle(edit) {
        if (edit) {
            // for title
            this._ToolbarService._ToolBarTitle.next("Update Certificate");
            // for btn
            this._ToolbarService._isBackBtnShow.next(true);
        } else {
            // for title
            this._ToolbarService._ToolBarTitle.next("Create Certificate");
            // for btn
            this._ToolbarService._isBackBtnShow.next(false);
        }
    }

    createForm(data?) {
        this.form = this._fb.group({
            templateData: [data || "", Validators.required],
            title: [data?.name || "", Validators.required],
            thumbnailImage: ["", Validators.required],
        });
    }

    openCropperForBg(event, isFor?) {
        console.log("isFor", event.target.files[0]);
        this.onFileUpload(event.target.files[0], event.target.files[0], isFor);
    }

    openCropperForProfile(event) {
        this._dialog
            .open<CropperComponent, any>(CropperComponent, {
                data: {
                    fileEvent: event,
                    myConfig: {
                        width: 300,
                        height: 300,
                        round: false,
                        type: "image/png",
                        keepAspectRatio: false,
                        responsiveArea: true,
                        // output: {
                        //     width: 300,
                        //     height: 300,
                        // },
                        resizableArea: true,
                    },
                },
                width: 520,
                height: 520,
                disableClose: true,
            })
            .afterClosed.subscribe((result: any) => {
                if (result) {
                    this.onFileUpload(
                        result.file,
                        result.blobFile,
                        "signature"
                    );
                }
            });
    }

    onFileUpload(fileObj, blobFile, isFor) {
        const payload = {
            fileExt: `.${String(fileObj?.type).slice(
                String(fileObj?.type).indexOf("/") + 1
            )}`,
            fileName: `${isFor == "thumbnail" ? "thumbnail_" : "background_"}`,
            folderName: `${isFor == "thumbnail"
                ? "certificate/thumbnail/image"
                : "ceritificate/layout/backgroundImage"
                }`, // it is fix set by backend.
            mimeType: `${fileObj?.type}`,
        };
        this._commonService.getPresignedUrlAPI(payload).then((result: any) => {
            if (result.status == 200) {
                // payload for get Image upload status
                const payload = {
                    id: result.data.id,
                    status: 1, // fix by backend.
                };
                this._commonService
                    .updateInPresignedUrlAPI(
                        result.data.presignedUrl,
                        fileObj.type,
                        blobFile
                    )
                    .then((res) => {
                        if (res) {
                            console.log("your file is uploaded here", res);
                            // this.templateBg  = result.data.imageUploadUrl;
                            if (isFor == "signature") {
                                this._certificateToolService.templateData.signature[
                                    "link"
                                ] = result.data.imageUploadUrl;
                            } else if (isFor == "thumbnail") {
                                this.form
                                    .get("thumbnailImage")
                                    .setValue(result.data.imageUploadUrl);
                                console.log("this.form", this.form);
                            } else if (isFor == "bg") {
                                this._certificateToolService.templateData.backgroundImage =
                                    result.data.imageUploadUrl;
                                this.getImageDimensions(
                                    result.data.imageUploadUrl
                                )
                                    .then((dimensions) => {
                                        console.log(
                                            "Image dimensions:",
                                            dimensions
                                        );

                                        this._certificateToolService.templateData.width =
                                            dimensions.width;
                                        this._certificateToolService.templateData.height =
                                            dimensions.height;
                                        this._certificateToolService.templateData.aspectRatio =
                                            String(dimensions.aspectRatio);
                                        this.dimensions = dimensions;
                                    })
                                    .catch((error) => {
                                        console.error(error);
                                    });
                                this.addCertificateImage(
                                    result.data.imageUploadUrl
                                );
                            }
                        }
                    });

                this._commonService
                    .getFileUploadStatus(payload)
                    .then((uploadStatusResponse: any) => {
                        if (uploadStatusResponse.status == 200) {
                            this._snackBar.open(
                                uploadStatusResponse.message,
                                "OKAY",
                                { duration: 2000 }
                            );
                        } else {
                            this._snackBar.open(
                                uploadStatusResponse.message,
                                "OKAY",
                                { duration: 2000 }
                            );
                        }
                    });
            }
        });
    }

    onZoomScale(zoomType: string) {
        if (zoomType == "+") {
            // if(this.zoomScale != 100)
            this.zoomScale += 10;
        } else {
            // if(this.zoomScale != 100)
            this.zoomScale -= 10;
        }

        if (this.showMoveableLine)
            this.showMoveableLine = false;

    }

    addNewLine(type, line) {
        this.lines.forEach(line => line.isActive = false);
        if (type == 'V') {
            const newLine = JSON.parse(JSON.stringify(line));
            newLine.position = newLine.percentage >= 50 ? newLine.position - 30 : newLine.position + 30;
            newLine.isActive = true;
            this.lines.push(newLine);
        } else {
            const newLine = JSON.parse(JSON.stringify(line));
            newLine.position = newLine.percentage >= 50 ? newLine.position - 30 : newLine.position + 30;
            newLine.isActive = true;
            this.lines.push(newLine);
        }
    }

    countLine(type) {
        if (type == 'V') {
            return this.lines.filter(line => line.type == 'V').length
        } else {
            return this.lines.filter(line => line.type == 'H').length
        }
    }

    removeLine(index) {
        this.lines.splice(index, 1)
        this.lines[this.lines.length - 1].isActive = true;
    }

    onResetZoom() {
        this.zoomScale = 100;
    }

    getImageDimensions(
        imageUrl: string
    ): Promise<{ width: number; height: number; aspectRatio: number }> {
        return new Promise((resolve, reject) => {
            const img = new Image();
            img.onload = () => {
                const width = img.width;
                const height = img.height;
                const aspectRatio = width / height;
                resolve({ width, height, aspectRatio });
            };
            img.onerror = (error) => {
                reject(`Failed to load image: ${error}`);
            };
            img.src = imageUrl;
        });
    }

    addCertificateImage(url) {
        this._commonService
            .addCertificateImage({ imageUrl: url })
            .then((res: any) => {
                if (res.status == 200) {
                    this.getAllBackgroundImages();
                }
            });
    }

    getAllBackgroundImages() {
        this._commonService
            .getAllCertificateBackgroundImage()
            .then((res: any) => {
                if (res.status == 200) {
                    this._certificateToolService.backgrounds = res.data;
                } else {
                    this._certificateToolService.backgrounds = [];
                }
            });
    }

    onSelectBg(i) {
        this._certificateToolService.backgrounds.forEach((item: any, j) => {
            if (j == i) {
                item.isSelected = 1;
                this._certificateToolService.templateData.backgroundImage =
                    item.imageUrl;
                this.getImageDimensions(item.imageUrl)
                    .then((dimensions) => {
                        this._certificateToolService.templateData.width =
                            dimensions.width;
                        this._certificateToolService.templateData.height =
                            dimensions.height;
                        this._certificateToolService.templateData.aspectRatio =
                            String(dimensions.aspectRatio);
                        this.dimensions = dimensions;
                        this.selectedEleId = "certificate";
                    })
                    .catch((error) => {
                        console.error(error);
                    });
            } else {
                item.isSelected = 0;
            }
        });
    }

    onDeleteBG(image) {
        let dialog = this._matDialog.open(ConfirmationDialogComponent, {
            panelClass: ["commonDialogWrapper"],
            backdropClass: "dialogBackdrop",
            disableClose: false,
            data: {
                message: "Are you sure you want to remove this ?",
                image: "/assets/ui/delete.png",
                focus: "right",
                deleteItem: "Remove Background?",
                confirmButtonText: "Yes",
                cancelButtonText: "No",
            },
        });
        // handle after close
        dialog.afterClosed().subscribe((res) => {
            if (res) {
                this._commonService
                    .certificateDeleteBgImage({ id: image.id })
                    .then((result: any) => {
                        if (result.status == 200) {
                            this.getAllBackgroundImages();
                            // check if deleteable image is selected then change the selected image
                            if (image.isSelected) {
                                this._certificateToolService.templateData.backgroundImage =
                                    "";
                            }
                        }
                        this._snackBar.open(result.message, "OKAY", {
                            duration: 2000,
                        });
                    });
            }
        });
    }

    isFileAllowed(fileName: string) {
        let isFileAllowed = false;
        const allowedFiles = [".jpeg", ".jpg", ".png", ".pdf"];
        const regex = /(?:\.([^.]+))?$/;
        const extension = regex.exec(fileName);

        if (isDevMode()) {
            console.log("extension du fichier : ", extension);
        }

        if (undefined !== extension && null !== extension) {
            for (const ext of allowedFiles) {
                if (ext === extension[0]) {
                    isFileAllowed = true;
                }
            }
        }

        return isFileAllowed;
    }


    onAddElement() {
        const tempField = JSON.parse(
            JSON.stringify(this._certificateToolService.newDynamicElement)
        );
        tempField.text = "";
        tempField.fieldName = "";
        tempField.contentEditable = true;

        if (
            this._certificateToolService.templateData.dynamicElements.length !=
            0
        )
            tempField.position.top =
                this._certificateToolService.templateData.dynamicElements
                    .length * 8;
        else tempField.position.top = 5;

        this._certificateToolService.templateData.dynamicElements.push(
            tempField
        );
        console.log(
            "this._certificateToolService.templateData.dynamicElements",
            this._certificateToolService.templateData.dynamicElements
        );
    }


    @HostListener('document:keydown.delete', ['$event'])
    handleDeleteKey(event: KeyboardEvent) {
        if (this.selectedEleId != null && this.parentElement === 'dynamicElements') {
            this.deleteElement(this.selectedEleId); // Your custom delete method
        }
    }


    deleteElement(index: number) {
        // const index = this._certificateToolService.templateData.dynamicElements.findIndex((el, i) => i === id);

        console.log("onKeyDown", index);
        // if (index !== -1) {
        this._certificateToolService.templateData.dynamicElements.splice(index, 1);
        this._cd.detectChanges()
        // this.selectedEleId = null; // Optionally clear selection
        // }
    }

    isNumber(value) {
        return Number(value)
    }


    onElementClick(event, eleType?, item?, index?) {

        console.log("hello in the item click ", eleType);



        if (this.menuState == 'in') this.menuState = 'out';

        if (eleType) {
            this.parentElement = eleType;
        } else {
            this.parentElement = "";
        }

        this.selectedEleId = "";
        this.selectedEleId = event?.target?.id
            ? event?.target?.id
            : String(index);
        console.log(
            "event.target.idselectedEleId",
            this.selectedEleId,
            this.parentElement
        );



        if (this.isPaintFormatActive && this.paintFormatCopiedElement && this.selectedEleId != 'certificate') {
            item.align = this.paintFormatCopiedElement.align;
            item.bold = this.paintFormatCopiedElement.bold;
            item.fontColor = this.paintFormatCopiedElement.fontColor;
            item.fontFamily = this.paintFormatCopiedElement.fontFamily;
            item.fontSize = this.paintFormatCopiedElement.fontSize;
            item.fontWeight = this.paintFormatCopiedElement.fontWeight;
            item.italic = this.paintFormatCopiedElement.italic;
            item.lineHeight = this.paintFormatCopiedElement.lineHeight;
            item.opacity = this.paintFormatCopiedElement.opacity;
            item.transform = this.paintFormatCopiedElement.transform;
            item.underline = this.paintFormatCopiedElement.underline;
            this.isPaintFormatActive = false;
            this.paintFormatCopiedElement = null;

            console.log("hello in the item click for signature", event.target.id);



        } else if (this.isPaintFormatActive && this.paintFormatCopiedElement && this.selectedEleId == 'certificate') {
            this.isPaintFormatActive = false;
            this.paintFormatCopiedElement = null;
        }


        if (
            event.target.id != "certificate" &&
            (!item?.isContentEditing || item?.link)
        ) {




            this.dragElement(
                document.getElementById(event.target.id),
                item,
                event.target.id
            );
        } else if (event.target.id == "certificate" && this.zoomScale > 100) {
            // this.dragElement(document.getElementById(event.target.id), item, event.target.id);
        }
    }

    dragElement(elmnt, item, id) {
        if (this.selectedEleId == id) {
            let pos1 = 0,
                pos2 = 0,
                pos3 = 0,
                pos4 = 0;
            // Store the initial click offset within the element
            let offsetX = 0;
            let offsetY = 0;
            const parentElement = document.getElementById("certificate");
            const rect = parentElement.getBoundingClientRect();

            function dragMouseDown(e) {
                e = e || window.event;
                e.preventDefault(); // Prevent default to avoid text selection during drag

                // Get the element's position and size
                const elmntRect = elmnt.getBoundingClientRect();

                // Calculate the offset of the mouse click within the element
                offsetX = e.clientX - elmntRect.left;
                offsetY = e.clientY - elmntRect.top;

                // Get the initial mouse cursor position
                pos3 = e.clientX;
                pos4 = e.clientY;

                document.onmouseup = closeDragElement;
                document.onmousemove = elementDrag;
            }

            function elementDrag(e) {
                e = e || window.event;
                e.preventDefault();

                // Update position references
                pos1 = pos3 - e.clientX;
                pos2 = pos4 - e.clientY;
                pos3 = e.clientX;
                pos4 = e.clientY;

                // Get the parent container's dimensions
                const parentRect = parentElement.getBoundingClientRect();

                // Get element dimensions
                const elmntRect = elmnt.getBoundingClientRect();
                const elmntWidth = elmntRect.width;
                const elmntHeight = elmntRect.height;

                // Calculate new position accounting for the click offset within the element
                let newX = e.clientX - offsetX - parentRect.left;
                let newY = e.clientY - offsetY - parentRect.top;

                // Apply boundary constraints
                // Right edge constraint
                if (newX + elmntWidth > parentRect.width) {
                    newX = parentRect.width - elmntWidth;
                }

                // Bottom edge constraint
                if (newY + elmntHeight > parentRect.height) {
                    newY = parentRect.height - elmntHeight;
                }

                // Left edge constraint
                if (newX < 0) {
                    newX = 0;
                }

                // Top edge constraint
                if (newY < 0) {
                    newY = 0;
                }

                // Convert to percentages
                const leftP = (newX / parentRect.width) * 100;
                const topP = (newY / parentRect.height) * 100;

                // Update element and item position
                elmnt.style.left = `${leftP}%`;
                elmnt.style.top = `${topP}%`;

                // Update item position data
                item.position.left = leftP;
                item.position.top = topP;
            }

            function closeDragElement() {
                document.onmouseup = null;
                document.onmousemove = null;
            }

            // Attach the mousedown event
            elmnt.onmousedown = dragMouseDown;
        }
    }


    resizeMouseDown(e: MouseEvent, item: any, direction: string) {
        e.preventDefault();
        e.stopPropagation();

        const elmnt = document.getElementById(String(this.selectedEleId));
        if (!elmnt) return;

        const parentElement = document.getElementById("certificate");
        if (!parentElement) return;

        const parentRect = parentElement.getBoundingClientRect();
        const elmntRect = elmnt.getBoundingClientRect();

        // Initial element dimensions
        const startWidth = elmntRect.width;
        const startHeight = elmntRect.height;
        const startLeft = elmnt.offsetLeft;
        const startTop = elmnt.offsetTop;

        // Initial mouse position
        const startX = e.clientX;
        const startY = e.clientY;

        // Calculate width and height as percentage of parent
        const widthPercent = (startWidth / parentRect.width) * 100;
        const heightPercent = (startHeight / parentRect.height) * 100;

        // Make sure item has width and height properties
        if (!item.width) {
            item.width = startWidth;
        }

        if (!item.height) {
            item.height = startHeight || (parseFloat(item.fontSize) * 1.5); // Set default height based on font size
        }

        const resize = (e: MouseEvent) => {
            e.preventDefault();

            // Calculate mouse movement delta
            const dx = e.clientX - startX;
            const dy = e.clientY - startY;

            // Calculate new dimensions based on resize direction
            let newWidth = startWidth;
            let newHeight = startHeight;
            let newLeft = startLeft;
            let newTop = startTop;

            // Handle different resize directions
            if (direction.includes('e')) {
                newWidth = startWidth + dx;
            }
            if (direction.includes('w')) {
                newWidth = startWidth - dx;
                newLeft = startLeft + dx;
            }
            if (direction.includes('s')) {
                newHeight = startHeight + dy;
            }
            if (direction.includes('n')) {
                newHeight = startHeight - dy;
                newTop = startTop + dy;
            }

            // Convert to percentages of parent container
            const widthPercentage = (newWidth / parentRect.width) * 100;
            const heightPercentage = (newHeight / parentRect.height) * 100;
            const leftPercentage = (newLeft / parentRect.width) * 100;
            const topPercentage = (newTop / parentRect.height) * 100;

            // Apply minimum size constraints
            const minWidth = 10; // Minimum width in pixels
            const minHeight = 10; // Minimum height in pixels

            // Boundary constraints to keep element within parent
            const rightEdge = newLeft + newWidth;
            const bottomEdge = newTop + newHeight;

            // Check if element would go outside parent boundaries
            const exceedsRight = rightEdge > parentRect.width;
            const exceedsBottom = bottomEdge > parentRect.height;
            const exceedsLeft = newLeft < 0;
            const exceedsTop = newTop < 0;

            // Apply constraints
            if (exceedsRight && direction.includes('e')) {
                newWidth = parentRect.width - newLeft;
            }

            if (exceedsBottom && direction.includes('s')) {
                newHeight = parentRect.height - newTop;
            }

            if (exceedsLeft && direction.includes('w')) {
                const adjustX = 0 - newLeft;
                newLeft = 0;
                newWidth = newWidth - adjustX;
            }

            if (exceedsTop && direction.includes('n')) {
                const adjustY = 0 - newTop;
                newTop = 0;
                newHeight = newHeight - adjustY;
            }

            // Apply size updates only if they meet constraints
            if (newWidth >= minWidth) {
                // Update width in pixels
                item.width = newWidth;
                // Update element style
                elmnt.style.width = `${newWidth}px`;
            }

            if (newHeight >= minHeight) {
                // Update height in pixels
                item.height = newHeight;
                // Update element style
                elmnt.style.height = `${newHeight}px`;
            }

            // Update position if needed (for n and w resizing)
            if (direction.includes('n') || direction.includes('w')) {
                if (direction.includes('w') && newWidth >= minWidth && newLeft >= 0) {
                    item.position.left = leftPercentage;
                    elmnt.style.left = `${leftPercentage}%`;
                }

                if (direction.includes('n') && newHeight >= minHeight && newTop >= 0) {
                    item.position.top = topPercentage;
                    elmnt.style.top = `${topPercentage}%`;
                }
            }
        };

        const stopResize = () => {
            document.removeEventListener('mousemove', resize);
            document.removeEventListener('mouseup', stopResize);
        };

        document.addEventListener('mousemove', resize);
        document.addEventListener('mouseup', stopResize);
    }

    resizeSignature(event: MouseEvent, direction: string, elementId: string) {
        event.preventDefault();
        event.stopPropagation();

        let element;
        if (elementId === 'signature') {
            element = this._certificateToolService.templateData.signature;
        } else {
            const index = parseInt(elementId);
            if (!isNaN(index) && this._certificateToolService.templateData.dynamicElements[index]) {
                element = this._certificateToolService.templateData.dynamicElements[index];
            }
        }

        if (!element) return;

        const startX = event.clientX;
        const startY = event.clientY;
        const startWidth = element.width || 100;
        const startHeight = element.height || 100;
        const startLeft = element.position.left;
        const startTop = element.position.top;

        const onMouseMove = (e: MouseEvent) => {
            const deltaX = e.clientX - startX;
            const deltaY = e.clientY - startY;

            let newWidth = startWidth;
            let newHeight = startHeight;
            let newLeft = startLeft;
            let newTop = startTop;

            // Resizing logic
            if (direction.includes('e')) {
                newWidth = Math.max(50, startWidth + deltaX);
            }
            if (direction.includes('w')) {
                newWidth = Math.max(50, startWidth - deltaX);
                newLeft = startLeft + (deltaX / this._certificateToolService.templateData.width * 100);
            }
            if (direction.includes('s')) {
                newHeight = Math.max(50, startHeight + deltaY);
            }
            if (direction.includes('n')) {
                newHeight = Math.max(50, startHeight - deltaY);
                newTop = startTop + (deltaY / this._certificateToolService.templateData.height * 100);
            }

            // Apply updated values
            element.width = newWidth;
            element.height = newHeight;
            element.position.left = newLeft;
            element.position.top = newTop;

            requestAnimationFrame(() => {
                const domElement = document.getElementById('signature');
                if (domElement) {
                    domElement.style.width = `${newWidth}px`;
                    domElement.style.height = `${newHeight}px`;
                    domElement.style.left = `${newLeft}%`;
                    domElement.style.top = `${newTop}%`;
                }
                this._cd.detectChanges();
            });
        };

        const onMouseUp = () => {
            document.removeEventListener('mousemove', onMouseMove);
            document.removeEventListener('mouseup', onMouseUp);
        };

        document.addEventListener('mousemove', onMouseMove);
        document.addEventListener('mouseup', onMouseUp);
    }


    onEditContent(item) {
        console.log("item --- ", item);
        this.openTextDailog(item);
    }

    openTextDailog(item) {
        const dialog = this._matDialog.open(CommonMessageSubmitComponent, {
            panelClass: ["commonDialogWrapper"],
            backdropClass: "dialogBackdrop",
            disableClose: true,
            width: "380px",
            autoFocus: true,
            data: {
                title: `Add Custom Text`,
                label: "Text",
                confirmButtonText: "Save",
                errorMsg: "Text is required.",
                text: item.text,
            },
        });
        dialog.afterClosed().subscribe((res) => {
            if (res) item.text = res;
        });
    }

    onShowHideEle(isShow) {
        if (this.parentElement == "")
            this._certificateToolService.templateData[
                this.selectedEleId
            ].display = isShow;
        else
            this._certificateToolService.templateData[this.parentElement][
                this.selectedEleId
            ].display = isShow;
    }

    globalAlign(val) {
        let selectedElement;
        if (this.parentElement == "") {
            selectedElement =
                this._certificateToolService.templateData[this.selectedEleId];
        } else {
            selectedElement =
                this._certificateToolService.templateData[this.parentElement][
                parseInt(this.selectedEleId)
                ];
        }

        console.log("val", val, "selectedElement", selectedElement);


        if (val == "hl") {
            selectedElement.position.left = 0;
        } else if (val == "hc") {
            if (selectedElement.elementType != 'text') {
                selectedElement.position.left = 50;
            } else {
                selectedElement.position.left = 50;
                selectedElement.position.tLeft = 50;
            }
        } else if (val == "hr") {
            selectedElement.position.left = 100;
        } else if (val == "vt") {
            selectedElement.position.top = 0;
        } else if (val == "vc") {
            if (selectedElement.elementType != 'text') {
                selectedElement.position.top = 50;
            } else {
                selectedElement.position.top = 50;
                selectedElement.position.tTop = 50;
            }
        } else if (val == "vb") {
            selectedElement.position.top = 100;
        }
    }

    mouseup() {
        clearInterval(this.clickTimer);
    }

    mousedown(key) {
        if (key == "lc") {
            this.clickTimer = setInterval(() => {
                this.leftClick();
            }, 100);
        } else if (key == "rc") {
            this.clickTimer = setInterval(() => {
                this.rightClick();
            }, 100);
        } else if (key == "uc") {
            this.clickTimer = setInterval(() => {
                this.upClick();
            }, 100);
        } else if (key == "dc") {
            this.clickTimer = setInterval(() => {
                this.downClick();
            }, 100);
        } else if (key == "rr") {
            this.clickTimer = setInterval(() => {
                this.rotateRight();
            }, 100);
        } else if (key == "rl") {
            this.clickTimer = setInterval(() => {
                this.rotateLeft();
            }, 100);
        }
    }

    leftClick() { // fsfd
        console.log("leftClick", this.selectedEleId);
        if (!(this.selectedEleId == "certificate")) {
            let selectedElement;
            if (this.parentElement == "") {
                selectedElement = this._certificateToolService.templateData[this.selectedEleId];
            } else {
                selectedElement = this._certificateToolService.templateData[this.parentElement][parseInt(this.selectedEleId)];
            }
            console.log("selectedElement?.positionleftClick", selectedElement?.position);
            if (selectedElement?.position?.left > 0) {
                selectedElement.position.left = (Number(selectedElement.position.left))
                selectedElement.position.left -= 0.1;
            }
            this._cd.detectChanges();
        }
    }

    rightClick() {
        console.log("rightClick", this.selectedEleId);
        if (!(this.selectedEleId == "certificate")) {
            let selectedElement;
            if (this.parentElement == "") {
                selectedElement = this._certificateToolService.templateData[this.selectedEleId];
            } else {
                selectedElement = this._certificateToolService.templateData[this.parentElement][parseInt(this.selectedEleId)];
            }
            console.log("selectedElement?.positionrightClick", selectedElement?.position);
            if (selectedElement?.position?.left > 0) {
                selectedElement.position.left = (Number(selectedElement.position.left))
                selectedElement.position.left += 0.1;
            }
            this._cd.detectChanges();
            // if (selectedElement.position.left < Number(this._certificateToolService.defaultTemplateFormat.width - selectedElement.width))
            //     selectedElement.position.left += 0.1;
        }
    }

    upClick() {
        console.log("upClick", this.selectedEleId);
        if (!(this.selectedEleId == "certificate")) {
            let selectedElement;
            if (this.parentElement == "") {
                selectedElement = this._certificateToolService.templateData[this.selectedEleId];
            } else {
                selectedElement = this._certificateToolService.templateData[this.parentElement][parseInt(this.selectedEleId)];
            }
            console.log("selectedElement?.positionupClick", selectedElement?.position);
            if (selectedElement.position.top > 0) {
                selectedElement.position.top = (Number(selectedElement.position.top -= 0.1));
                selectedElement.position.top -= 0.1;
            }
            this._cd.detectChanges();
        }
    }

    downClick() {
        console.log("downClick", this.selectedEleId);
        if (!(this.selectedEleId == "certificate")) {
            let selectedElement;
            if (this.parentElement == "") {
                selectedElement = this._certificateToolService.templateData[this.selectedEleId];
            } else {
                selectedElement = this._certificateToolService.templateData[this.parentElement][parseInt(this.selectedEleId)];
            }
            console.log("selectedElement?.positiondownClick", selectedElement?.position);
            if (selectedElement.position.top < 310) {
                selectedElement.position.top = Number(selectedElement.position.top += 0.1);
                selectedElement.position.top += 0.1;
            }
            this._cd.detectChanges();
        }
    }

    rotateRight() {
        this.clickTimer = setInterval(() => {
            let selectedElement;
            if (this.parentElement == "") {
                selectedElement =
                    this._certificateToolService.templateData[
                    this.selectedEleId
                    ];
            } else {
                selectedElement =
                    this._certificateToolService.templateData[
                    this.parentElement
                    ][parseInt(this.selectedEleId)];
            }
            selectedElement.rotate++;
        }, 1);
    }

    rotateLeft() {
        this.clickTimer = setInterval(() => {
            let selectedElement;
            if (this.parentElement == "") {
                selectedElement =
                    this._certificateToolService.templateData[
                    this.selectedEleId
                    ];
            } else {
                selectedElement =
                    this._certificateToolService.templateData[
                    this.parentElement
                    ][parseInt(this.selectedEleId)];
            }
            selectedElement.rotate--;
        }, 1);
    }

    changeFont(opreators) {
        console.log("this.selectedEleId", this.selectedEleId);
        if (
            this._certificateToolService.templateData.dynamicElements[
                this.selectedEleId
            ].fontSize > 8 &&
            opreators === "-"
        ) {
            this.parentElement == ""
                ? this._certificateToolService.templateData.dynamicElements[
                    this.selectedEleId
                ].fontSize--
                : this._certificateToolService.templateData[this.parentElement][
                    this.selectedEleId
                ].fontSize--;
        } else if (
            this._certificateToolService.templateData.dynamicElements[
                this.selectedEleId
            ].fontSize < 150 &&
            opreators === "+"
        ) {
            this.parentElement == ""
                ? this._certificateToolService.templateData.dynamicElements[
                    this.selectedEleId
                ].fontSize++
                : this._certificateToolService.templateData[this.parentElement][
                    this.selectedEleId
                ].fontSize++;
        }
    }

    setFontColor(color) {
        this.parentElement == ""
            ? (this._certificateToolService.templateData.dynamicElements[
                this.selectedEleId
            ].fontColor = color)
            : (this._certificateToolService.templateData[this.parentElement][
                this.selectedEleId
            ].fontColor = color);
    }

    onBoldClick() {
        if (this.parentElement == "") {
            this._certificateToolService.templateData.dynamicElements[
                this.selectedEleId
            ].bold =
                !this._certificateToolService.templateData.dynamicElements[
                    this.selectedEleId
                ].bold;
        } else
            this._certificateToolService.templateData[this.parentElement][
                this.selectedEleId
            ].bold =
                !this._certificateToolService.templateData[this.parentElement][
                    this.selectedEleId
                ].bold;
    }

    onItalicClick() {
        if (this.parentElement == "") {
            this._certificateToolService.templateData.dynamicElements[
                this.selectedEleId
            ].italic =
                !this._certificateToolService.templateData.dynamicElements[
                    this.selectedEleId
                ].italic;
        } else
            this._certificateToolService.templateData[this.parentElement][
                this.selectedEleId
            ].italic =
                !this._certificateToolService.templateData[this.parentElement][
                    this.selectedEleId
                ].italic;
    }
    onTextTransform(type) {
        this._certificateToolService.templateData.dynamicElements[this.selectedEleId].transform = type;
    }

    onUnderlineClick() {
        if (this.parentElement == "") {
            this._certificateToolService.templateData.dynamicElements[
                this.selectedEleId
            ].underline =
                !this._certificateToolService.templateData.dynamicElements[
                    this.selectedEleId
                ].underline;
        } else
            this._certificateToolService.templateData[this.parentElement][
                this.selectedEleId
            ].underline =
                !this._certificateToolService.templateData[this.parentElement][
                    this.selectedEleId
                ].underline;
    }

    localAlign(value) {
        if (!value) return;

        if (this.parentElement == "") {
            this._certificateToolService.templateData.dynamicElements[
                this.selectedEleId
            ].align = value;
        } else {
            this._certificateToolService.templateData[this.parentElement][
                parseInt(this.selectedEleId)
            ].align = value;
        }
    }

    onSaveCerificate() {
        // change font size
        const scaleFactor = Number(this._certificateToolService.templateData.width / 1053);

        const payloadTemplateData = JSON.parse(JSON.stringify(this._certificateToolService.templateData))

        // Scale dynamic elements and ensure text property is set
        payloadTemplateData.dynamicElements.forEach((element) => {

            console.log("createField", element);

            // Ensure text property is set
            if (!element.text && element.fieldName) {
                element.text = element.fieldName;
            }

            element.fontSize = Math.trunc(Number(element.fontSize * scaleFactor))
            element.lineHeight = element.fontSize;

            if (element?.width != 'auto' && element?.width) {
                element.width = Math.trunc(Number(element.width * scaleFactor));
            }
        });



        console.log("payloadTemplateData", payloadTemplateData);




        // Scale signature dimensions
        if (payloadTemplateData.signature && payloadTemplateData.signature.width) {
            payloadTemplateData.signature.width = Number(payloadTemplateData.signature.width);
            payloadTemplateData.signature.height = Number(payloadTemplateData.signature.height);
            payloadTemplateData.signature.scaleFactorWidth = Number(payloadTemplateData.signature.width * scaleFactor);
            payloadTemplateData.signature.scaleFactorHeight = Number(payloadTemplateData.signature.height * scaleFactor);
        }

        if (this._CertificateUpdateService.templateDetails) {
            const payload = {
                id: this._CertificateUpdateService.templateDetails.id,
                name: this.form.get("title").value,
                backgroundImage:
                    this._certificateToolService.templateData.backgroundImage,
                layout: payloadTemplateData,
                thumbnailImage: this.form.get("thumbnailImage").value,
                attachType: this.currentTab == "Contact Actions" ? 1 : 2
            };
            console.log("final payload", payload);

            this._commonService
                .onUpdateCertificate(payload)
                .then((res: any) => {
                    if (res.status == 200) {
                        this._snackBar.open(res.message, "OKAY", {
                            duration: 2000,
                        });
                        this._router.navigate(["/certificate/templates"]);
                    } else {
                        this._snackBar.open(res.message, "OKAY", {
                            duration: 3000,
                        });
                    }
                });
        } else {
            const payload = {
                name: this.form.get("title").value,
                backgroundImage:
                    this._certificateToolService.templateData.backgroundImage,
                layout: payloadTemplateData,
                thumbnailImage: this.form.get("thumbnailImage").value,
                attachType: this.currentTab == "Contact Actions" ? 1 : 2
            };

            console.log("payloadafter", payload);
            this._commonService.onAddCertificate(payload).then((res: any) => {
                if (res.status == 200) {
                    this._snackBar.open(res.message, "OKAY", {
                        duration: 2000,
                    });
                    this._router.navigate(["/certificate/templates"]);
                } else {
                    this._snackBar.open(res.message, "OKAY", {
                        duration: 3000,
                    });
                }
            });
        }
    }

    onDeleteElement(item) {
        const index =
            this._certificateToolService.templateData.dynamicElements.findIndex(
                (element) => element == item
            );
        this._certificateToolService.templateData.dynamicElements.splice(
            index,
            1
        );
        this.selectedEleId = "certificate";
        this.parentElement = "";
    }

    openCropperForSignature(event) { }

    ngOnDestroy(): void {
        document.removeEventListener("mousemove", this.mouseMoveHandler);
        document.removeEventListener("mouseup", this.mouseUpHandler);
        // Unsubscribe to avoid memory leaks
        this.percentageSubjects.forEach((subject) => subject.unsubscribe());

        this._certificateToolService.templateData = {
            backgroundImage: "",
            dynamicElements: [],
            fontFamilyCdn:
                "https://fonts.googleapis.com/css2?family=Barlow:wght@100;200;300;400;500;600;700;800;900&family=Bilbo&family=Dancing+Script:wght@400;500;600;700&family=Fleur+De+Leah&family=Kaushan+Script&family=Playball&family=Poppins:wght@100;200;300;400;500;600;700;800;900&family=Qwigley&family=Roboto:wght@100;300;400;500;700;900&family=Sail&family=Sansita+Swashed:wght@300;500;700;900&family=Six+Caps&family=Tangerine:wght@400;700&display=swap",
            signature: {
                elementType: "image",
                link: "",
                width: 100,
                display: true,
                opacity: 1,
                rotate: 0,
                position: {
                    top: 31.99,
                    left: 90.5,
                },
            },
            width: 868,
            height: 608,
            aspectRatio: "",
        };

        this._certificateToolService.defaultTemplateFormat = {
            backgroundImage: "",
            dynamicElements: [],
            width: 868,
            height: 608,
            signature: {
                elementType: "image",
                link: "",
                display: true,
                opacity: 1,
                rotate: 0,
                position: {
                    top: 31.99,
                    left: 90.5,
                },
            },
            aspectRatio: "",
        };

        this._CertificateUpdateService.templateDetails = null;
    }

    onRemoveSignature() {
        this._certificateToolService.templateData.signature = {
            link: "",
            width: 100,
            elementType: "image",
            display: true,
            opacity: 1,
            rotate: 0,
            position: { top: 31.99, left: 90.5 },
        };
        this.selectedEleId = "";
    }

    formatPercentage(value) {
        let num = parseFloat(value); // Convert string to number
        return num.toFixed(2) + "%"; // Round to 2 decimal places and add '%'
    }

    onDeleteField(index) {
        this.selectedEleId = "certificate";
        this.parentElement = "";
        this._certificateToolService.templateData.dynamicElements.splice(
            index,
            1
        );
    }

    onDuplicateFields(field) {
        console.log("field====>>", field);
        const newField = JSON.parse(JSON.stringify(field));
        newField.position.left = Math.trunc(newField.position.left) > 50 ? Number(newField.position.left - 5) : Number(newField.position.left + 5);
        newField.position.top = Math.trunc(newField.position.top) > 50 ? Number(newField.position.top - 5) : Number(newField.position.top + 5);
        console.log("newField====>>", newField);
        this._certificateToolService.templateData.dynamicElements.push(newField);
        this._cd.detectChanges();
    }

    onLineStartDrag(event: MouseEvent, lineIndex: number, line: any) {

        this.onActiveLine(line);

        event.preventDefault();
        this.lines[lineIndex].isDragging = true;

        document.addEventListener('mousemove', this.onMouseMove.bind(this, lineIndex));
        document.addEventListener('mouseup', this.onMouseUp.bind(this, lineIndex));
    }


    @HostListener("document:mousemove", ["$event"])
    onMouseMove(event: MouseEvent) {
        console.log("hello in mouse move", event);

        const draggingLine = this.lines.find(line => line.isDragging);
        if (!draggingLine) return;

        if (draggingLine.type === 'V' && this.parentContainer) {
            const parentRect = this.parentContainer.nativeElement.getBoundingClientRect();
            const newPosition = event.clientX - parentRect.left;
            if (newPosition >= 0 && newPosition <= parentRect.width) {
                draggingLine.position = newPosition - 2;
                draggingLine.percentage = this.getPercentage(newPosition, draggingLine.type);
            }
        } else if (draggingLine.type === 'H' && this.parentContainer) {
            const parentRect = this.parentContainer.nativeElement.getBoundingClientRect();
            const newPosition = event.clientY - parentRect.top;
            if (newPosition >= 0 && newPosition <= parentRect.height) {
                draggingLine.position = newPosition - 2;
                draggingLine.percentage = this.getPercentage(newPosition, draggingLine.type);
            }
        }
    }

    @HostListener("document:mouseup")
    onMouseUp = () => {
        this.lines.forEach((line) => (line.isDragging = false));

        // Remove event listeners using stored references
        document.removeEventListener('mousemove', this.mouseMoveHandler);
        document.removeEventListener('mouseup', this.mouseUpHandler);
    };

    getPercentage(value: number, type: string) {
        if (this.parentContainer?.nativeElement) {
            const parentRect = this.parentContainer.nativeElement.getBoundingClientRect();

            // Check type: 'V' -> use width; 'H' -> use height
            if (type === 'V') {
                return Math.round((value / parentRect.width) * 100);
            } else if (type === 'H') {
                return Math.round((value / parentRect.height) * 100);
            }
        }
        return 0;
    }

    onActiveLine(line) {
        this.lines.forEach(item => item.isActive = false);
        line.isActive = true;
    }


    onPaintFormat() {
        if (!this.isPaintFormatActive) this.isPaintFormatActive = true;
        this.paintFormatCopiedElement = JSON.parse(JSON.stringify(this._certificateToolService.templateData.dynamicElements[this.selectedEleId]));
    }


    updateSampleText(element: any, event: any) {
        // Update the sampleValue property of the element
        element.sampleValue = event.target.value;

        // Force change detection to update the view
        this._cd.detectChanges();
    }

    getSampleValue(value, fieldName) {
        if (value == undefined || value == null) {
            return fieldName.replace(/{{.*?}}/g, "");

        } else {
            return value
        }
    }

    updatePosition(element: any, event: any, type: 'top' | 'left') {
        let value = Number(event.target.value);

        // Clamp the value between 0 and 100
        value = Math.max(0, Math.min(100, value));
        value = parseFloat(value.toFixed(2));

        if (type === 'top') {
            element.position.top = value;
        } else {
            element.position.left = value;
        }

        this._cd.detectChanges();
    }

    onMouseMoved(event: MouseEvent): void {
        const target = event.target as HTMLElement;
        const rect = target.getBoundingClientRect();

        this.cursorX = Math.trunc(event.clientX - rect.left);
        this.cursorY = Math.trunc(event.clientY - rect.top);

        console.log(" this.cursorX", rect.left, " this.cursorY", event.clientY);


    }



}
